module.exports = __webpack_public_path__ + "img/grid-3x3-gap.e64c9f6b.svg";